(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 1840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(8074);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst_meta_image.f5a4009b.png","height":640,"width":1240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUXCk0nG1ke+WECAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgQAKMjOgMMAAAAGwABa6H6+kAAAAASUVORK5CYII="});

/***/ }),

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 8074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/views/About/About.module.less
var About_module = __webpack_require__(4898);
var About_module_default = /*#__PURE__*/__webpack_require__.n(About_module);
// EXTERNAL MODULE: ./src/landingPage/components/Hero/index.jsx + 10 modules
var Hero = __webpack_require__(16717);
// EXTERNAL MODULE: ./src/landingPage/components/Section/index.jsx + 17 modules
var Section = __webpack_require__(1699);
;// CONCATENATED MODULE: ./src/landingPage/assets/team/jake.png
/* harmony default export */ var jake = ({"src":"/_next/static/media/jake.a22430d7.png","height":421,"width":356,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAUVBMVEVMaXFtfYGhqqq+vLyIeXO4l44xN0pWTEkmHyljh3qTd248OUNHPSiCXVE7Jh+ikZFRZH4WGCtRZHxmZmsYExVlUUudnJfw4Ny5o6E7R15EVXXbEeeBAAAAFHRSTlMAQXvWw/7+N/4K+5wZ6+nZtf1U350TsCsAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA7SURBVHicHcdJEoAgDADBUQETN1CDoP9/qAWnrgZ0UAB1z9icfZm6S43Nbfeu/8j3BatYDm9CzOQM3w8rJQHcvLmBogAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/mark.png
/* harmony default export */ var mark = ({"src":"/_next/static/media/mark.040e3f3d.png","height":360,"width":356,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVRUVF8Xlm8lofYoJRPSk0/NTc2MTZmVFgyMjxMQkj/39IRFCmjh4E+QVHZopOKh5Pmq5knKjiNfIFIS2Dcwr+lrcHouKs0N0qbenHwxbf0uq7j5Ot0eI1HOzrcr59GSl72+P9cqBPkAAAAFnRSTlMBmviEYNKHHZ5E+klRuO3mtOqU/v77XR1RowAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEJJREFUeJwVxkUWwCAQBNGOAjGiM1jk/qfM69rUB2C624L1oQ4tUcnwOKKJaTHEJGnlRx9lBzBryWfZHF498nep/QFR8gMFI6nl4wAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/nicole.png
/* harmony default export */ var nicole = ({"src":"/_next/static/media/nicole.2309a563.png","height":387,"width":356,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAY1BMVEVMaXFGNyt3goloYlfUxLpaSC9JPzVtdHhdYV59kbt1gJRnY1g/RVRmUzPgwK5OQTSDYkVKQj9FQkFzc39pdoQfICiFcFueiHqupJqIhIMtMDxsXU2jg2SXgWsxLy9eTkmKna0XM2SvAAAAFXRSTlMA/onQ+fn+JlMMXa+F1/yg/cbqFqpsqT8KAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nAXBBwKAIAwAsUOZLlwtbv3/K02AWAWAZt/qBLTFnhFSf1vNENw16ATBu9HMC91j1MvKIW8R+X5D3QLCD+yNmAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/anna.png
/* harmony default export */ var anna = ({"src":"/_next/static/media/anna.6815162c.png","height":370,"width":355,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAXVBMVEWFl298LYY5QTmMhH+UzomelpR1K3uQI5lBTU1RWlqfkZHLtbVgV06ciY9EC1XRtbW1pqR1QX1tD3vY0sCtdqOSO5jj1NLUv8Hr496eUJ/jxsR2L359OoTn2c/evNn8ewfuAAAAGXRSTlMB5KOaDfth/h/AroDbJ7bwp4Dpmv39///+IPYi6AAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEBJREFUeJwdxlcSgCAQBcFHXIJiQAmm+x/TYudnGoDz3mGkipGM0OrEiFdZGfNSt3GbTN8toMV9EH0ZWjwn9fb+QC8CXyqzADgAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/scott.png
/* harmony default export */ var scott = ({"src":"/_next/static/media/scott.599721e3.png","height":242,"width":204,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAXVBMVEVMaXEsHRHRm4SbfG0vNEgkKTkNDx4TCgoaDgjEkn9nPy5TPC5DLSG5kXzjppBEMyurd2MnKUS5ra5fYXArLkU3O1s9P0hcOiysnJaPYVDBno/dqZOkbV7Kz9SVlp1q8r2aAAAAFHRSTlMAcur99THCBzv91NyXxi7PXNf+dm31imoAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA/SURBVHicJclJEoAgDADBcQ24IZjg7v+faVme+tAgQ18AOO9XB8zn71RenXwx7kFAlqPKbUO0tGWtMbsfVX0BQDgCnDJWP5YAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/julien.png
/* harmony default export */ var julien = ({"src":"/_next/static/media/julien.05ed8c5b.png","height":1282,"width":986,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAASFBMVEULDxIlKilwZFSJjIU6PjOFiY1xemkCBQmcl4lQVk61r6J9ZVFlWkprbGyGc2R9gYOTi347KBvCwLZvSTPe4N2ofWSmd1fQn38cLdj2AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAOElEQVR4nBXBiRGAIAwAwQMCSQBFwaf/Th13serBhWq9SWEezxsTl627F5KcLTho3PnlrICOTfkAMHgBhqtTM8gAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/chris.png
/* harmony default export */ var chris = ({"src":"/_next/static/media/chris.446ff4d2.png","height":1804,"width":1290,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAUVBMVEVyeIOnhW7WsZVmYGG4jFmwknHJonm9l3XOrYa4kWi5gGSfdlxfZG59goxrb3mOkZncvpq3j3mrhFSOeFtKUF1janc0NjzOjGzes3qCZlW2nog7ujeXAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAOElEQVR4nAXBBwKAIAwAsWO2bHDr/x9qgqgP0SOhmPggZlmdpJSzVba93N/Ene7tgwMYnavSWv0BMWwB9wsxnKYAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/aoife.png
/* harmony default export */ var aoife = ({"src":"/_next/static/media/aoife.bd494de9.png","height":258,"width":242,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAASFBMVEVMaXGjjXnTtp+gg2zDrZari25wX06BZVDatJxeQS+2loT//+5OPSqfhG+2oIq9oYPYqpCfjGzjzbXuzbu9m4SwjXTavKqylHzrHtptAAAAFXRSTlMA9Jf8ZEOT/Pw4jS5buteR+iiB/f5ynIKyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAO0lEQVR4nB3IWRKAIAzA0LC24q4F739Tp+TrTQC2hVkVmbrDO6ojS+q74+yXHo74qYUVeJKaZV8ltgI/M/gBjn+kCIcAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/views/About/components/LocationMap.module.less
var LocationMap_module = __webpack_require__(25093);
var LocationMap_module_default = /*#__PURE__*/__webpack_require__.n(LocationMap_module);
;// CONCATENATED MODULE: ./src/landingPage/views/About/components/LocationMap.jsx



function LocationMap() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "1202",
        height: "720",
        viewBox: "0 0 601 360",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                id: "earth_a",
                x: "0",
                y: "0",
                width: "7.7",
                height: "7.7",
                patternUnits: "userSpaceOnUse",
                patternContentUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "#5140B3",
                    fillOpacity: ".5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "1",
                            cy: "1",
                            r: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "4.85",
                            cy: "1",
                            r: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            transform: "translate(1.93 3.85)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "-2.85",
                                    cy: "1",
                                    r: "1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "1",
                                    cy: "1",
                                    r: "1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "4.85",
                                    cy: "1",
                                    r: "1"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("mask", {
                id: "earth_b",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 0h601v360H0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fillRule: "evenodd",
                        fill: "#fff",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M0 26h2l.5-1h1l.5-1h2l1-2h-.5L6 21H5l-.5-1H5l1.5-3H5l-.5-1H5l.5-1H7l.5 1H8l.5-1H8l-.5-1H8l.5-1H11l-1.5-3H13l.5-1h1l.5-1h2.5l.5 1h1l1 2h2l1 2h2.5l.5-1h.5l.5 1h.5l1.5-3h1l.5-1h2l1-2H32l-.5-1H34l.5-1h3l.5-1h1.5l.5 1h.5l.5-1h1.5l.5 1h.5l1-2h1l.5-1h2l.5-1H48l-.5-1h8L57 3h3.5l.5-1h5.5l.5 1h1l1.5 3h1l1 2H70l-1.5 3h.5l.5 1H68l-.5 1h1l-1 2h1l-.5 1h-1l-.5 1h1l-.5 1h-1l-.5 1h1L65 22h-3l-1 2h-2l-2 4h-2.5l-.5-1h-1l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1H54l.5-1H54l-.5-1h.5l.5-1H52l-.5-1h-1l-1-2h.5l.5-1h-1L48 12h-1.5l1 2h-1l.5 1h1l.5 1h-1l.5 1h1l.5 1h-1l1.5 3h1.5L50 24h-1.5l1 2h-2l2 4H49l-.5 1H50l1.5 3H51l-.5 1h1l-1 2h-2l-.5 1h-2l-.5 1h-2l-.5 1h-1l-1 2h-1l-.5 1h1l-.5 1h-1l-1 2h-1l-.5 1h3l-1 2h2l-1 2H42l.5 1H45l-.5 1h-8L35 56h3l.5-1h6l1-2h.5l.5 1h.5l-1.5 3H47l.5 1h2l.5 1h1.5l-1 2H54l.5 1h1l.5 1h2.5l-1 2h1L57 68h-1l-.5 1h1l-1 2h1l-1 2h-2l-.5 1h-1l-.5 1h1L51 78h-1l-2 4h-1l-2 4h.5l1 2h-2l1.5 3h1.5l-.5 1h-1l-.5 1H44l-.5-1h-1l-2-4h.5l.5-1h-2l1-2h-1l1-2h-1l1-2h-1l2-4h-1l1-2h-1l1-2h-1l1-2H40l-1-2h-1l-2-4h-1.5l1-2h-1l1.5-3h1.5l-1-2h-2l-.5-1h-1l-1-2h-2l-.5-1h-2l-.5-1h-2l-1.5-3h-2l-2-4h.5l.5-1H19l-1.5-3h.5l.5-1h-2l1-2h-1l2-4h-1l.5-1h1l.5-1h-2l1-2H17l-1.5-3H17l.5-1h-2l1-2h-1l1-2h-5l-.5 1h-1l-.5 1h-3L6 26H3l-.5 1h-3zm35.5-16H37l-.5 1H36zm-7 3h2l-1 2H29l-1-2m9 2h1.5l-.5 1h-.5zm6 5h.5l.5 1h1.5l-.5 1h-2l-.5 1h-1zm8-13h1l.5 1h-1zM37 24h1l.5-1h.5l1 2h1l1 2h-.5L40 30h-1.5l-.5-1h-1l-1.5-3h.5zm8 1h1.5l-.5 1h-.5zM33 46h.5l.5 1h1.5L34 50h-3.5l1 2h-1l-.5-1h-1.5l1-2h-1l.5-1h1l.5-1h2zm1.5 5h3l-1 2h-3z",
                                transform: "matrix(3.85 0 0 3.85 0 -.96)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M64.5 23h5l-1 2h.5l.5 1h-5l-1-2h.5zM79.5 7h.5l.5 1h1l1 2H82l-.5 1h1l-1 2h-1l-.5 1h-1.5L77 11h-1.5l1-2h1l.5-1h1zM89 4h3.5l1 2H92l-.5 1h1L92 8h-3l-.5 1H88l-.5-1h-1l-1-2H88zM100 2h1.5l.5 1h1l.5 1h2l.5 1h2l1 2h3.5l-1 2h2l-.5 1h3l.5-1h2.5l1 2h1.5l.5-1h1.5l-.5-1h-1l-.5-1h-.5l-.5 1h-1l1-2h-3l1.5-3h5.5l1 2H122l-.5 1h2.5l.5 1h3l.5 1h1.5l.5-1h.5l.5 1h3.5l.5-1h2l.5-1h3.5l.5 1h4l.5 1h1.5l-1 2h1l-.5 1h-2.5l2 4h-.5l-2 4h-1.5l1 2h-1l1 2h-.5l-.5 1h2l-.5 1h-1.5l1 2h-1l1 2H142l-.5 1h-.5l-.5-1h1l-3-6h1l-1-2h.5l1-2h-2.5l1 2h-.5l-.5 1h-3l-.5 1h-1l-.5 1h1l-1 2h4l-1 2h2l-1 2h2l-1 2h1l-1 2h-2l-1 2h-1l-1 2h.5l1 2h1.5l1.5-3h-.5l-1-2h1.5l.5-1h1l.5-1h1l.5-1h1l-3 6h1l-1 2h1l-.5 1h-1l-1 2h-2.5l1 2h-.5l-1 2h-1l1-2h.5l-1-2h-1l-.5-1h-1.5l1-2h-1l-1 2h.5l1 2h.5l-1 2h1l-1 2h1l-1 2h2l-.5 1h-.5l1.5 3h1.5l-1 2h2l-.5 1h-1.5l.5 1h1l1 2h3l.5 1h4l.5 1h.5l.5-1h1.5l.5 1h1l1 2h2.5l-1 2H149l-1-2h-1.5l-1 2H143l-.5-1h-1l2.5 5h1.5l-1 2h2l-1 2h1l-1 2h1l-1.5 3h-1l-.5 1h1l-.5 1h-1l-1.5 3h1l-.5 1h-1l-.5 1h-2l1-2h-.5l-1-2h-1l-2-4h-2.5l-.5 1h-5.5l-1-2h2l-2-4h.5l1-2h1l.5-1h1l.5-1h1l1-2h3.5l-1-2h-.5l-.5 1H130l-.5-1h-5l-.5-1h-1l-1-2h-2.5l1-2h-.5l-2-4h1l.5 1h1l-1-2h.5l.5-1h-.5l-.5-1h-1l-1.5-3h-1.5l-.5 1h-1l-1 2h-1.5l2 4h-.5l-.5 1H111l-1-2h-1.5l1-2h-2l1-2h-.5l-1-2h-1l-1-2h-2.5l-1 2h1l-.5 1h-1l-1 2h-2l-.5 1h3l-.5 1h-1l-2 4h-1l-1 2h-1l-1.5 3h.5l.5 1H95l-.5 1h-1l-1 2h1l-.5 1h-1l-1.5 3h1l-.5 1h-2.5l1 2h-2l1 2h-3l.5 1h-4l-1.5-3h1l-.5-1h-1.5l1-2H80l-1.5-3h1l-1-2h1l-.5-1h1l-3-6h1l-.5-1h-1l-.5-1h-4.5l-.5 1h-.5l-.5-1h-2l-1-2h-1.5l1-2h-2l2-4h-2l.5-1h1l.5-1h-1l.5-1h1l.5-1h1l1-2h-1l.5-1h1l.5-1h-2l1-2h-1l1.5-3h1.5l.5 1h1l-1-2h-1.5l1-2h-3l1-2h-1l.5-1h1.5l-1-2h.5l.5-1h3l-1 2h2l-1 2h2l.5-1h1.5l-.5-1h-1l-1.5-3h1l-1-2H76l1-2h1.5l-1-2h.5l1-2h2l.5-1H86l.5 1h1l.5 1h.5l.5-1h2l1.5-3h-1l1-2h-1l1.5-3h1l1-2h1.5l1 2H96l-2.5 5H95l.5 1h1l.5 1h1l-1-2h.5l1-2h-1l.5-1h3l1-2h-1l-.5 1h-1l1-2h2l.5-1h1.5l-1-2h2l-.5-1h-2l-.5-1h-2l-1-2h1l-1-2zm1.5 6h1l.5 1h-1zM92 19h3l.5 1h-3zm-11 8h1l.5 1h-1zm0 4h1l.5 1h-1zm-5.5 9h1l1 2h-1zm3.5 1h1l.5 1h-1zm7.5-3h1l1 2h-1zM81 43h3l.5 1h3l.5 1h-8l-1-2h1l.5 1h1zm9-4h1l.5 1h-1zm26.5 15h1l1 2h-.5l-.5 1h-1l.5-1h.5zm10-4h3l1 2h-1l1 2h-1l1 2h-2l1 2H128l-1 2h-1l.5-1h-1l-1 2h.5l.5 1h-1l-1-2h1l-1-2h.5l.5-1h1l1-2h-1l1-2h-1l.5-1h1.5zm3.5 7h1l.5 1h-1zm1 2h2l.5 1h-2zm2 2h1l.5 1h-1zm-8 2h2l.5 1h-2zm2.5 1h2l.5 1h-2zm5 0h3l1 2h-1l-.5-1h-2zm5.5 0h.5l1 2h1.5l-1.5 3h-1l1-2h-3zm3.5-10h1l.5 1h-1zm10 14h1l.5 1h1.5l-1 2h1l-1.5 3h-.5l-.5-1h-1.5l1-2h.5l.5 1h1m0 9h2l-1 2h2l-2 4h-1l-.5 1h-1l-1.5 3h-3l1-2h-.5l-.5-1h2.5l1-2h1l1.5-3h-1zM95 67h3.5l-1 2h1l-.5 1h-1l-.5 1h1L96 74h-1.5l-.5-1h-1l-.5-1h2l-1-2h1l-1-2h2",
                                transform: "matrix(3.85 0 0 3.85 0 -.96)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                id: "earth_mask_signal",
                className: (LocationMap_module_default()).Earth_mask_signal,
                x: "0",
                y: "0",
                width: "1",
                height: "720",
                fill: "#5140B3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "100%",
                height: "100%",
                fill: "url(#earth_a)",
                mask: "url(#earth_b)",
                transform: "scale(.999 1.0077)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#earth_filter0_d)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_0",
                        className: (LocationMap_module_default()).Earth_point_0,
                        x: "100",
                        y: "78",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint0_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_0),
                        cx: "105",
                        cy: "83",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_1",
                        className: (LocationMap_module_default()).Earth_point_1,
                        x: "163",
                        y: "130",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint1_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_1),
                        cx: "168",
                        cy: "135",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_2",
                        className: (LocationMap_module_default()).Earth_point_2,
                        x: "163",
                        y: "332",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint2_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_2),
                        cx: "168",
                        cy: "337",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_3",
                        className: (LocationMap_module_default()).Earth_point_3,
                        x: "300",
                        y: "110",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint3_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_3),
                        cx: "305",
                        cy: "115",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_5",
                        className: (LocationMap_module_default()).Earth_point_5,
                        x: "370",
                        y: "175",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint5_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_5),
                        cx: "375",
                        cy: "180",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_6",
                        className: (LocationMap_module_default()).Earth_point_6,
                        x: "425",
                        y: "180",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint6_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_6),
                        cx: "430",
                        cy: "185",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_7",
                        className: (LocationMap_module_default()).Earth_point_7,
                        x: "470",
                        y: "235",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint7_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_7),
                        cx: "475",
                        cy: "240",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_8",
                        className: (LocationMap_module_default()).Earth_point_8,
                        x: "521",
                        y: "278",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint8_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_8),
                        cx: "526",
                        cy: "283",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_9",
                        className: (LocationMap_module_default()).Earth_point_9,
                        x: "271",
                        y: "125",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint9_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_9),
                        cx: "276",
                        cy: "130",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_10",
                        className: (LocationMap_module_default()).Earth_point_10,
                        x: "291",
                        y: "135",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint10_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_10),
                        cx: "296",
                        cy: "140",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_11",
                        className: (LocationMap_module_default()).Earth_point_11,
                        x: "521",
                        y: "148",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint11_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_11),
                        cx: "526",
                        cy: "153",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_12",
                        className: (LocationMap_module_default()).Earth_point_12,
                        x: "581",
                        y: "328",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint12_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_12),
                        cx: "586",
                        cy: "333",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_13",
                        className: (LocationMap_module_default()).Earth_point_13,
                        x: "331",
                        y: "125",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint13_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_13),
                        cx: "336",
                        cy: "130",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_14",
                        className: (LocationMap_module_default()).Earth_point_14,
                        x: "470",
                        y: "205",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint14_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_14),
                        cx: "475",
                        cy: "210",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_15",
                        className: (LocationMap_module_default()).Earth_point_15,
                        x: "495",
                        y: "230",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint15_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_15),
                        cx: "500",
                        cy: "235",
                        r: "10px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "earth_filter0_d",
                        x: "0",
                        y: "0",
                        width: "1202",
                        height: "720",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint0_linear",
                        x1: "118",
                        y1: "132",
                        x2: "145.4493",
                        y2: "84.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint1_linear",
                        x1: "181",
                        y1: "184",
                        x2: "208.4493",
                        y2: "136.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint2_linear",
                        x1: "181",
                        y1: "386",
                        x2: "208.4493",
                        y2: "338.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint3_linear",
                        x1: "318",
                        y1: "164",
                        x2: "345.4493",
                        y2: "116.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint5_linear",
                        x1: "388",
                        y1: "229",
                        x2: "415.4493",
                        y2: "181.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint6_linear",
                        x1: "443",
                        y1: "234",
                        x2: "470.4493",
                        y2: "186.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint7_linear",
                        x1: "488",
                        y1: "289",
                        x2: "515.4493",
                        y2: "2141.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint8_linear",
                        x1: "540",
                        y1: "332",
                        x2: "566.4493",
                        y2: "284.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint9_linear",
                        x1: "310",
                        y1: "179",
                        x2: "336.4493",
                        y2: "131.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint10_linear",
                        x1: "330",
                        y1: "189",
                        x2: "356.4493",
                        y2: "141.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint11_linear",
                        x1: "540",
                        y1: "202",
                        x2: "566.4493",
                        y2: "154.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint12_linear",
                        x1: "620",
                        y1: "382",
                        x2: "646.4493",
                        y2: "334.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint13_linear",
                        x1: "370",
                        y1: "179",
                        x2: "396.4493",
                        y2: "131.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint14_linear",
                        x1: "488",
                        y1: "289",
                        x2: "515.4493",
                        y2: "241.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint15_linear",
                        x1: "503",
                        y1: "314",
                        x2: "540.4493",
                        y2: "266.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.jsx + 2 modules
var SecurityBadges = __webpack_require__(69753);
// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/BottomCta.jsx
var BottomCta = __webpack_require__(72062);
;// CONCATENATED MODULE: ./src/landingPage/views/About/About.jsx

















var About = function() {
    var execTeam = [
        {
            name: "Jake Moore",
            role: "Chief Revenue Officer",
            img: jake,
            linkedin: "https://www.linkedin.com/in/jakeotismoore/"
        },
        {
            name: "Scott Albin",
            role: "Chief Strategy Officer",
            img: scott,
            linkedin: "https://www.linkedin.com/in/scottalbin/"
        },
        {
            name: "Chris Hyde",
            role: "Chief Information Officer",
            img: chris,
            linkedin: "https://www.linkedin.com/in/chris-hyde-6787623/"
        },
        {
            name: "Anna Bondarenko",
            role: "Chief Operating Officer",
            location: "Dubai, United Arab Emirates",
            img: anna,
            linkedin: "https://www.linkedin.com/in/annabonda/"
        },
        {
            name: "Nicole DeMaise",
            role: "Chief Legal Officer",
            img: nicole,
            linkedin: "https://www.linkedin.com/in/nicole-demaise-81a0a5191/"
        },
        {
            name: "Mark Hookey",
            role: "Founder and Chief Executive Officer",
            img: mark,
            linkedin: "https://www.linkedin.com/in/markhookey/"
        },
        {
            name: "Julien Bonnier",
            role: "VP of Product",
            img: julien,
            linkedin: "https://www.linkedin.com/in/julienbonnier/"
        },
        {
            name: "Aoife Fallon Lee",
            role: "Head of Finance",
            img: aoife,
            linkedin: "https://www.linkedin.com/in/aoife-fallon-lee-aca-ba28a737/"
        }, 
    ];
    var locations = [
        {
            city: "New York",
            address: "149 E 23rd Street, Suite 2035",
            address2: "New York, NY 10010"
        },
        {
            city: "Australia",
            address: "Suite 902 (Level 9), 146 Arthur Street",
            address2: "North Sydney, NSW 2060"
        },
        {
            city: "Singapore",
            address: "9 Raffles Place, #26-01, Republic Plaza",
            address2: "Singapore 048619"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* Hero */.VM, {
                background: "violet-1000",
                withStarsAnimation: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* HeroCol */.Zx, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* HeroTitle */.LR, {
                            children: "Unlock the power of external data"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* HeroSubtitle */.RV, {
                            children: "Demyst believes that external data is the next frontier of business impact, yet it is often locked away. Organizations want to harness more value from the extensive external data ecosystem and meet their data governance goals. Demyst supports enterprise external data management with a market leading product and managed service to empower your central data teams, and analytics and business stakeholders across the enterprise."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-25",
                masthead: {
                    title: "Our history and future",
                    subtitle: [
                        "We started in 2010 upon realizing that, while the world is supposedly awash with data,             very little of it is being used for customer benefit. 80% of analytics projects failed             at the ideation, discovery, or deployment phase, with true business impact rarely             realized despite the clear possibilities.",
                        "We have evolved a technology platform that underpins our service, enabling us to             partner closely with the most innovative organizations to collaboratively take on the             most detailed aspects of their data projects. Over 100 of the most exacting banks and             insurers have discovered and deploy the world's best external data through Demyst for             any and all of their use cases including KYC, credit, risk, marketing and more.", 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "white",
                type: "one-col",
                masthead: {
                    title: "The Demyst Executive Team"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (About_module_default()).Team,
                        children: execTeam.map(function(p) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (About_module_default()).Exec,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (About_module_default()).Image,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: p.img.src,
                                            alt: p.name,
                                            width: "356",
                                            height: "420",
                                            layout: "responsive"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                        className: (About_module_default()).Name,
                                        type: "h3",
                                        children: p.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                        className: (About_module_default()).Role,
                                        asParagraph: true,
                                        type: "h4",
                                        children: p.role
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: p.linkedin,
                                        isExternal: true,
                                        className: (About_module_default()).Linkedin,
                                        title: "View Linkedin Account",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiLinkedin */.qOw, {
                                            alt: "Linkedin Icon"
                                        })
                                    })
                                ]
                            }, p.name);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "violet-900",
                type: "one-col",
                masthead: {
                    title: "Our market",
                    subtitle: [
                        "Current geography list: Australia, Austria, Brazil, Canada, India, Pakistan, Philippines, Singapore, South Africa, Ukraine, United Arab Emirates, United States.", 
                    ]
                },
                removeBottomPadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (About_module_default()).Earth,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationMap, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "violet-900",
                type: "three-col",
                masthead: {
                    title: "Our offices"
                },
                children: locations.map(function(l) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (About_module_default()).Location,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiMapPin */.i63, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                    children: l.city
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionParagraph */.Lo, {
                                    children: [
                                        l.address,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        l.address2
                                    ]
                                })
                            ]
                        })
                    }, l.city);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-800",
                type: "one-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCta/* BottomCta */.W, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-1000",
                removeBottomPadding: true,
                removeTopPadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityBadges/* SecurityBadges */.U, {})
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
;// CONCATENATED MODULE: ./pages/about-us.jsx




var AboutUsPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/about-us",
                title: meta/* meta.about.title */.$.about.title,
                description: meta/* meta.about.description */.$.about.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var about_us = (AboutUsPage);


/***/ }),

/***/ 72062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ BottomCta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1699);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25504);
/* harmony import */ var _BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67039);
/* harmony import */ var _BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3__);




var BottomCta = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().divReadyToGetStarted),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_1__/* .SectionHeading */ .OT, {
                        type: "h2",
                        children: "Ready to get started?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().lestUsSectionColor),
                        children: "See why our customer continue to trust and leverage Demyst to accelerate their external data initiatives."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* .CtaLinkButton */ .k8, {
                    autoWidth: true,
                    classNameDiv: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().letUsButton),
                    className: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().letUsText),
                    text: "Let us show you how"
                })
            })
        ]
    });
};


/***/ }),

/***/ 69753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ SecurityBadges; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/components/Badge/Badge.module.less
var Badge_module = __webpack_require__(86919);
var Badge_module_default = /*#__PURE__*/__webpack_require__.n(Badge_module);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/landingPage/components/Badge/Badge.jsx




var Badge = function(param) {
    var icon = param.icon, _background = param.background, background = _background === void 0 ? "violet-1000" : _background, children = param.children;
    var backgroundClassName = typeof background === "string" ? background.replace(/-/g, "_").toLowerCase() : typeof background === "object" ? background.map(function(bg) {
        return bg.replace(/-/g, "_").toLowerCase();
    }).join("_to_") : null;
    var iconToShow = icon ? typeof icon === "function" ? icon() : typeof icon === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: icon,
        alt: ""
    }) : null : typeof icon === "object" ? icon : /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiCheckCircle */._rq, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Badge_module_default()).Badge, (Badge_module_default())[backgroundClassName]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Badge_module_default()).BadgeIcon,
                children: iconToShow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Badge_module_default()).BadgeLabel,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Badge/index.jsx


// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.module.less
var SecurityBadges_module = __webpack_require__(68760);
var SecurityBadges_module_default = /*#__PURE__*/__webpack_require__.n(SecurityBadges_module);
;// CONCATENATED MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.jsx



var SecurityBadges = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SecurityBadges_module_default()).SecurityBadges,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "SOC 2 Type II"
                    }),
                    " Certified"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "GDPR"
                    }),
                    " Compliant"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "CCPA"
                    }),
                    " Compliant"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "FCRA"
                    }),
                    " Compliant"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "GLBA"
                    }),
                    " Compliant"
                ]
            })
        ]
    });
};


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ meta; }
/* harmony export */ });
var meta = {
    homepage: {
        title: "Demyst: The External Data Management Platform",
        description: "Demyst enables data teams to manage all their external data. External data orchestration at scale, with pipelines that provide trusted external data."
    },
    platform: {
        title: "The Demyst Platform",
        description: "Use Demyst to build your External Data Hub. Demyst provides the end-to-end platform you need to onboard and ingest the right external data into your Data Hub, with our experts working closely with you every step of the way."
    },
    platform_discover: {
        title: "Data Discovery",
        description: "Access hundreds of fully integrated sources, or easily request something new with the Demyst Platform."
    },
    platform_management: {
        title: "Maintenance & Support",
        description: "Simplify the management of all your external data with a single global interface to reduce maintenance burden and maximize value."
    },
    platform_governance: {
        title: "Governance, Procurement & Compliance",
        description: "Say goodbye to the “Compliance Versus Speed” trade-off. Meet industry leading compliance practices whilst typically onboarding new data in four weeks or less."
    },
    platform_deployment: {
        title: "Deployment",
        description: "Deploy up to ten times the data, ten times faster with the Demyst Platform."
    },
    whydataops: {
        title: "Frictionless External Data",
        description: "Keeping pace with the expanding universe of external data is painful without the right technology supporting you."
    },
    ccpa: {
        title: "CCPA",
        description: "Personal Information Request Form for California Residents"
    },
    dsar: {
        title: "DSAR",
        description: "Data Subject Action Request"
    },
    case_study: {
        title: "Resources",
        description: "Meet the industry leaders across the globe that are unlocking the power of external data with Demyst."
    },
    about: {
        title: "About us",
        description: "Demyst believes that external data is the next frontier of business impact, able to power competitive advantages in industries around the world with improved decisioning, new products and better efficiencies."
    },
    contact: {
        title: "Contact us",
        description: "Contact us with the form below to learn how Demyst helps you discover, access, license, and deploy data using our end-to-end EDaaS (External Data as a Service) offering, or if you have any other general inquiries."
    },
    request: {
        title: "Schedule a Demo",
        description: "Schedule a Demo with the form below to learn how the Demyst platform empowers users to discover, access, license, and deploy external data."
    },
    careers: {
        title: "Careers",
        description: "Join our team to immerse yourself in an ecosystem of strategic business challenges and opportunities and awe-inspiring data access."
    },
    report: {
        title: "Free Discovery Report",
        description: "Our free data discovery report gives you a summary of the specific data sources, attributes, analytics, and integration models you can use to solve your business challenges."
    },
    privacy: {
        title: "Privacy Policy",
        description: "This Privacy Policy describes what information we collect when you use our Software, how we use that information, and what choices we offer you to access, update, and control it."
    },
    accessibility: {
        title: "Accessibility Policy",
        description: "This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible"
    },
    terms: {
        title: "Terms and Conditions",
        description: "Demyst Data Limited and its affiliated companies (together, “Demyst Data” or “we” and sometimes “us”) provide the websites www.demystdev.wpengine.com and demystdata.com (collectively, the “Website”) and the Demyst Data software and libraries (collectively referred to herein as the/our “Software” or the/our “Services”), subject to your agreement to and compliance with these Terms and Conditions (the “Terms”)."
    },
    cookies: {
        title: "Cookies Policy",
        description: "This policy explains the different cookies used by Demyst Data on our corporate website and on our Platform (collectively, “Site”) and how you can control them. We may change this Cookie Policy at any time. Please look at the “Last Updated” date at the top of this page to see when this Cookie Policy was last revised. Any changes in this Cookie Policy will become effective when we make the revised Cookie Policy available on or through the  Site. Please see our Privacy Notice to understand the other ways we use the personal information we collect about you."
    },
    subprocessor: {
        title: "Sub-processor Policy",
        description: "Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a“Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data."
    },
    business: {
        title: "Business Data",
        description: "Harness hundreds of operationalized data sources and marketplaces, through a single API."
    },
    demystvs: {
        title: "Demyst vs. Data Consulting",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxfincrime: {
        title: "Demyst DataOps for FinCrime",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxpartnership: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxexchange: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst and the Amazon Web Services (AWS) Data Exchange help customers get data into production to achieve data-driven business outcomes faster."
    },
    industries: {
        financialservices: {
            title: "Financial Services Industry",
            description: "Rapidly deploy the right external data solutions for financial services. Optimize your external data spend with a single platform."
        },
        insurance: {
            title: "Insurance Industry",
            description: "Rapidly deploy the right external data solutions for insurance."
        }
    },
    enterprise: {
        title: "Enterprise",
        description: "Delivering End-To-End Value Across The Enterprise."
    },
    newsletter: {
        title: "Newsletter",
        description: "A weekly summary of Demyst product activities and general news impacting the market for external data."
    },
    pricing: {
        title: "Pricing",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    partners: {
        title: "Partners",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    usecases: {
        bnpl: {
            title: "Automate Buy Now, Pay Later",
            description: "Access ready-to-deploy data APIs for KYC, Fraud, Compliance and Credit Decisioning , aggregating global data from multiple data partners into a single, configurable data feed."
        },
        kyc: {
            title: "KYC Workflow Automation",
            description: "A single platform for seamless onboarding and verification of customers globally."
        },
        kyb: {
            title: "KYB Workflow Automation",
            description: "A single platform for seamless onboarding and verification of businesses globally."
        },
        applicationprefill: {
            title: "Application Prefill Optimization",
            description: "A single platform for prefilling data pertaining to people, places, and businesses, globally."
        },
        dataenrichment: {
            title: "Enrich Leads",
            description: "A single platform to identify new leads (person, place, business) globally."
        },
        leadtargeting: {
            title: "Optimize Lead Targeting",
            description: "A single platform to identify new leads, enrich leads, and priortiize leads across people, places, and businesses, globally."
        },
        portfoliomonitoring: {
            title: "Optimize Portfolio Monitoring",
            description: "A single platform to enrich customer profiles for retention and cross-sell intiatives"
        },
        businessdecisioning: {
            title: "Business Customer Onboarding",
            description: "Build an initial business customer profile to enable improved new business onboarding decisions and minimize risk exposure."
        },
        creditbureau: {
            title: "Optimize Credit Decisioning",
            description: "A single platform to integrate and manage credit bureau feeds globally."
        }
    }
};


/***/ }),

/***/ 37672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NextHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34631);
/* harmony import */ var _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79550);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_NonceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25455);







var createMetaTitle = function(title) {
    var displayCompany = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var companyName = "Demyst";
    if (!title) {
        return companyName;
    }
    if (displayCompany) {
        return "".concat(title, " | ").concat(companyName);
    }
    return title;
};
var trimAndClipText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var trimmedText = text.trim();
    if (trimmedText.length > length) {
        return "".concat(trimmedText.substr(0, length - 1), "…");
    }
    return trimmedText;
};
var NextHead = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _displayCompanyName = param.displayCompanyName, displayCompanyName = _displayCompanyName === void 0 ? true : _displayCompanyName, pageImageUrl = param.pageImageUrl, pageImageWidth = param.pageImageWidth, pageImageHeight = param.pageImageHeight, canonical = param.canonical, _pageType = param.pageType, pageType = _pageType === void 0 ? "website" : _pageType, currentPath = param.currentPath;
    var nonce = (0,_context_NonceContext__WEBPACK_IMPORTED_MODULE_5__/* .useNonce */ .X)().nonce;
    var formattedTitle = trimAndClipText(createMetaTitle(title, displayCompanyName), 75);
    var formattedDescription = description.length && trimAndClipText(description);
    var originUrl = "https://demyst.com";
    var currentUrl = originUrl + currentPath;
    var canonicalUrl = canonical ? originUrl + canonical : currentUrl;
    var imageUrl = function() {
        if (pageImageUrl) return pageImageUrl;
        return originUrl + _assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src;
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
        nonce: nonce,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: formattedTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: formattedDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@demystdata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:domain",
                content: "demyst.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            pageImageHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: pageImageHeight
            }),
            pageImageWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: pageImageWidth
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                dangerouslySetInnerHTML: {
                    __html: "window[(function(_CP2,_RC){var _cW8T4='';for(var _LSEFSL=0;_LSEFSL<_CP2.length;_LSEFSL++){_3Kz3!=_LSEFSL;var _3Kz3=_CP2[_LSEFSL].charCodeAt();_RC>9;_3Kz3-=_RC;_3Kz3+=61;_3Kz3%=94;_3Kz3+=33;_cW8T4==_cW8T4;_cW8T4+=String.fromCharCode(_3Kz3)}return _cW8T4})(atob('XEtSdHFsZ2V2TWd7'), 2)] = 'a6f395c0d81699221108';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_Nut,_cV){var _PHNl8='';for(var _qmZeLE=0;_qmZeLE<_Nut.length;_qmZeLE++){var _9810=_Nut[_qmZeLE].charCodeAt();_9810-=_cV;_9810+=61;_9810%=94;_9810+=33;_9810!=_qmZeLE;_cV>5;_PHNl8==_PHNl8;_PHNl8+=String.fromCharCode(_9810)}return _PHNl8})(atob('Lzs7NzpfVFQxOlNBMFI6KjkwNzs6Uyo2NFRBMFI7KC5TMTo='), 37)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     }); "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: pageType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context":"https://schema.org",\n            "@graph": [\n              {\n                "@type":"Organization",\n                "name":"Demyst",\n                "url":"'.concat(originUrl, '",\n                "logo":"').concat(originUrl + _assets_svg_DemystLogo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, '",\n                "sameAs":[\n                  "https://twitter.com/demystdata",\n                  "https://www.linkedin.com/company/demystdata"\n                ]\n              },\n              {\n                "@type":"WebSite",\n                "@id":"').concat(originUrl, '/#website",\n                "url":"').concat(originUrl, '",\n                "name":"Demyst",\n                "inLanguage":"en-US"\n              },\n              {\n                "@type":"WebPage",\n                "@id":"').concat(currentUrl, '#webpage",\n                "url":"').concat(currentUrl, '",\n                "name":"').concat(formattedTitle, '",\n                "isPartOf":{\n                  "@id":"').concat(originUrl, '/#website"\n                },\n                "inLanguage":"en-US",\n                ').concat(description && '"description":"'.concat(formattedDescription, '",'), '\n                "potentialAction":[\n                  {\n                    "@type":"ReadAction",\n                    "target":[\n                      "').concat(currentUrl, '"\n                    ]\n                  },\n                  {\n                    "@type": "SearchAction",\n                    "target": "').concat(originUrl + _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.DATA_CATALOG_CONNECTORS */ .s.DATA_CATALOG_CONNECTORS, '?search={search_term_string}",\n                    "query-input": "required name=search_term_string"\n                  }\n                ]\n              }\n            ]\n          }')
                }
            }),
            children
        ]
    });
};
NextHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.node,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string,
    displayCompanyName: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    sendPageView: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string
};


/***/ }),

/***/ 86919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Badge":"Badge_Badge__XqccE","blue_800":"Badge_blue_800__umxh_","blue_900":"Badge_blue_900__B9XkS","blue_1000":"Badge_blue_1000__UZDMq","violet_1000":"Badge_violet_1000__So3zY","BadgeLabel":"Badge_BadgeLabel__vt7Tn"};

/***/ }),

/***/ 67039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BottomCta":"BottomCta_BottomCta__VRmZc","lestUsSectionColor":"BottomCta_lestUsSectionColor__cKutT","letUsText":"BottomCta_letUsText__TbXdV","divReadyToGetStarted":"BottomCta_divReadyToGetStarted__nkl4j","letUsButton":"BottomCta_letUsButton__0YB3K","BottomCtaCol":"BottomCta_BottomCtaCol__xDN69","BottomCtaList":"BottomCta_BottomCtaList__1rBcr","BottomCtaListItem":"BottomCta_BottomCtaListItem__Ojioj"};

/***/ }),

/***/ 68760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SecurityBadges":"SecurityBadges_SecurityBadges__RilZo"};

/***/ }),

/***/ 4898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Team":"About_Team__Xo8Pg","Exec":"About_Exec__y5ds_","Image":"About_Image__yx65m","Name":"About_Name__FszWE","Role":"About_Role__xrTSg","Loc":"About_Loc__C8cp3","Linkedin":"About_Linkedin__KG_fj","Location":"About_Location__aW9qC","Earth":"About_Earth__7HJMj"};

/***/ }),

/***/ 25093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Pulse":"LocationMap_Pulse__2MahK","Pulse_0":"LocationMap_Pulse_0__VdaPI","Pulse_1":"LocationMap_Pulse_1__CfBIo","Pulse_2":"LocationMap_Pulse_2__9494V","Pulse_3":"LocationMap_Pulse_3__rCWax","Pulse_5":"LocationMap_Pulse_5__euZzA","Pulse_6":"LocationMap_Pulse_6__1DZjx","Pulse_7":"LocationMap_Pulse_7__hlVnE","Pulse_8":"LocationMap_Pulse_8__qAnBH","Pulse_9":"LocationMap_Pulse_9___9B0_","Pulse_10":"LocationMap_Pulse_10__BwBPc","Pulse_11":"LocationMap_Pulse_11__SB_de","Pulse_12":"LocationMap_Pulse_12__5EypV","Pulse_13":"LocationMap_Pulse_13__RJog8","Pulse_14":"LocationMap_Pulse_14__UBXFh","Pulse_15":"LocationMap_Pulse_15__MX_84","Earth_mask_signal":"LocationMap_Earth_mask_signal__XRW8G","signal_moving":"LocationMap_signal_moving__gR12W","Earth_point_0":"LocationMap_Earth_point_0__qiJgx","point_appearing_0":"LocationMap_point_appearing_0__SLIAb","Earth_point_1":"LocationMap_Earth_point_1__f_2SZ","point_appearing_1":"LocationMap_point_appearing_1__cs5NT","Earth_point_2":"LocationMap_Earth_point_2__CZuRK","point_appearing_2":"LocationMap_point_appearing_2__YBa8x","Earth_point_3":"LocationMap_Earth_point_3__Jn54E","point_appearing_3":"LocationMap_point_appearing_3__KQ1uK","Earth_point_5":"LocationMap_Earth_point_5__xEm5G","point_appearing_5":"LocationMap_point_appearing_5__uewRA","Earth_point_6":"LocationMap_Earth_point_6__eRPjL","point_appearing_6":"LocationMap_point_appearing_6__sIZ_x","Earth_point_7":"LocationMap_Earth_point_7__uFU3H","point_appearing_7":"LocationMap_point_appearing_7__vTHxw","Earth_point_8":"LocationMap_Earth_point_8__5W26V","point_appearing_8":"LocationMap_point_appearing_8__UNFTs","Earth_point_9":"LocationMap_Earth_point_9__2Y61c","point_appearing_9":"LocationMap_point_appearing_9__OedHz","Earth_point_10":"LocationMap_Earth_point_10__nlI1h","point_appearing_10":"LocationMap_point_appearing_10__liSTb","Earth_point_11":"LocationMap_Earth_point_11__yB6OJ","point_appearing_11":"LocationMap_point_appearing_11__d4eSe","Earth_point_12":"LocationMap_Earth_point_12__fWL8F","point_appearing_12":"LocationMap_point_appearing_12__gIlBd","Earth_point_13":"LocationMap_Earth_point_13__wYvUa","point_appearing_13":"LocationMap_point_appearing_13___f_7q","Earth_point_14":"LocationMap_Earth_point_14__BuBvh","point_appearing_14":"LocationMap_point_appearing_14__lg3Qg","Earth_point_15":"LocationMap_Earth_point_15__Z__3D","point_appearing_15":"LocationMap_point_appearing_15__DFn5f"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,5675,9223,4280,9774,2888,179], function() { return __webpack_exec__(1840); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);